import { ApiSearchResults } from 'api/search';

// Types

export type MainStoreOrgDashboardSearchState = {
  orgId?: string;
  apiKey?: string;
  pageIndex: number;
  type: string;
  status: string;
  query: string;
  results: ApiSearchResults | null | undefined;
  typeCounts: Record<string, number> | null | undefined;
  filters: {
    isFetching: boolean;
    status: Array<string>;
  };
};

export type SearchStartAction = {
  type: 'ORG_DASHBOARD_SEARCH_START';
  orgId: string;
  apiKey: string;
  listingType: string;
  status: string;
  query: string;
  pageIndex: number;
};

export type SearchSuccessAction = {
  type: 'ORG_DASHBOARD_SEARCH_SUCCESS';
  results: ApiSearchResults;
};

export type SetTypeCountsAction = {
  type: 'ORG_DASHBOARD_SET_TYPE_COUNTS';
  typeCounts: Record<string, number>;
};

export type FacetsStartAction = {
  type: 'ORG_DASHBOARD_FACETS_START';
};

export type FacetsSuccessAction = {
  type: 'ORG_DASHBOARD_FACETS_SUCCESS';
  facets: {
    status: Record<string, number>;
  };
};

export type MainStoreOrgDashboardSearchAction =
  | SearchSuccessAction
  | SearchStartAction
  | SetTypeCountsAction
  | FacetsStartAction
  | FacetsSuccessAction;

// Reducer

const initialState = {
  pageIndex: 0,
  type: 'ALL',
  status: 'ALL',
  query: '',
  results: null,
  typeCounts: null,
  filters: {
    status: [],
    isFetching: false,
  },
};

export function searchReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreOrgDashboardSearchState = initialState,
  action: MainStoreOrgDashboardSearchAction,
) {
  switch (action.type) {
    case 'ORG_DASHBOARD_SEARCH_START': {
      const { orgId, apiKey, listingType, status, query, pageIndex } = action;
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line prefer-object-spread
      return Object.assign({}, state, {
        orgId,
        apiKey,
        pageIndex,
        type: listingType,
        status,
        query,
        results: state.results,
        typeCounts: orgId === state.orgId ? state.typeCounts : null,
      });
    }

    case 'ORG_DASHBOARD_SEARCH_SUCCESS':
      return { ...state, results: action.results };

    case 'ORG_DASHBOARD_SET_TYPE_COUNTS':
      return { ...state, typeCounts: action.typeCounts };

    case 'ORG_DASHBOARD_FACETS_START': {
      return { ...state, filters: { ...state.filters, isFetching: true } };
    }

    case 'ORG_DASHBOARD_FACETS_SUCCESS': {
      const orgStatuses: Array<string> = Object.keys(
        action.facets.status || {},
      );
      return {
        ...state,
        filters: {
          status: orgStatuses,
          isFetching: false,
        },
      };
    }

    default:
      return state;
  }
}
